import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import AuthorCredit from './AuthorCredit';

const frameSx = {
  minHeight: { xs: '100%', sm: '100vh' },
  display: 'flex',
  flexDirection: 'column',
} as const;

export default function GuestPageFrame({ children, sx }: { children: ReactNode; sx?: SxProps<Theme> }) {
  return (
    <Box sx={sx ? [frameSx, ...(Array.isArray(sx) ? sx : [sx])] : frameSx}>
      {children}
      <AuthorCredit />
    </Box>
  );
}
